import { Outlet } from 'react-router-dom';
import { AppHeader } from '@/widgets/app-bar';
import { PageBreadcrumb } from '@/widgets/breadcrumb';

/**
 * Main application layout wrapper
 * Includes the app header and provides consistent spacing for page content
 * Applied to all authenticated routes (excludes login, welcome, 404 pages)
 */
export function MainLayout() {
	return (
		<div className="min-h-screen bg-brand-page-bg">
			<AppHeader />
			<main className="container mx-auto px-4 py-4 md:px-8 md:py-8">
				<PageBreadcrumb />
				<Outlet />
			</main>
		</div>
	);
}
